<app-multi-value-tile
  [applicationId]="application.id"
  [installationId]="(installation$ | async)?.id"
  [tileTitle]="headerTitle ? headerTitle : 'setpoint-tile.title' | translate"
  [values]="values$ | async"
  [columns]="3"
  [showAdjust]="true"
  (adjust)="adjustSetpoint()">
</app-multi-value-tile>
